import { render, staticRenderFns } from "./GroupShortname.vue?vue&type=template&id=93aac7ec&"
import script from "./GroupShortname.vue?vue&type=script&lang=js&"
export * from "./GroupShortname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports